import { C } from "../data/content";

export const Audience = () => (
  <section id="learn" className="py-28 px-6 lg:px-12" data-testid="audience-section">
    <div className="max-w-[1440px] mx-auto">
      <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-6">[003] — WHO THIS IS FOR</p>
      <h2 className="h1-display text-[clamp(28px,3.4vw,48px)] mb-12">THIS TRAINING IS DESIGNED FOR:</h2>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {C.audienceCards.map((c, i) => (
          <div key={i} className="aud-card p-6 flex flex-col gap-4" data-testid={`audience-card-${i + 1}`}>
            <span className="text-3xl">{c.icon}</span>
            <p className="text-[13px] font-bold uppercase leading-snug tracking-wide">{c.text}</p>
          </div>
        ))}
      </div>
      <button className="btn-accent cta mt-12" data-testid="audience-cta"
        onClick={() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" })}>
        ✓ RESERVE MY FREE SEAT
      </button>
    </div>
  </section>
);

export const Roadmap = ({ items = C.roadmap }) => (
  <section className="border-y border-white/[0.06]" data-testid="roadmap-section">
    <div className={`max-w-[1440px] mx-auto grid ${items.length === 3 ? "md:grid-cols-3" : "md:grid-cols-4"}`}>
      {items.map((r, i) => (
        <div key={i} className={`relative p-10 overflow-hidden ${i < items.length - 1 ? "md:border-r border-b md:border-b-0 border-white/[0.06]" : ""}`} data-testid={`roadmap-step-${i + 1}`}>
          <span className="mono absolute -top-4 -right-2 text-[120px] font-bold text-white/[0.04] leading-none select-none">{r.step}</span>
          <p className="mono text-[10px] tracking-[0.3em] text-[var(--accent)] mb-4">STEP {r.step}</p>
          <h3 className="font-black uppercase text-xl mb-3">{r.name}</h3>
          <p className="text-[13px] text-white/45 leading-relaxed">{r.desc}</p>
        </div>
      ))}
    </div>
  </section>
);
